// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"489":"4d6d566f","1940":"4d6d566f","2057":"4d6d566f","2339":"4d6d566f","4618":"67780f3a","6021":"5b9c0ca3","8541":"4d6d566f"}[chunkId] + ".chunk.css";
};